module.exports = __webpack_public_path__ + "img/card_ip_stipulation6163.348e895f.svg";